module.exports = __webpack_public_path__ + "static/media/Taco Tuesday.b78cdb84.jpg";